import { useEffect, useState } from 'react'
import axios from 'axios';
import Loading from '../../../component/common/loading/Loading';
import PopupDataGrid from '../../../component/common/popup/PopupDataGrid';
import ExcelDownload from '../../../component/common/button/ExcelDownload';

const BoardCheck_popup = () => {
    const [data, setData] = useState([{}]);

    const head = ['기관구분', '소속기관', '지역', '수신자', '조회 확인 시간'];
    const head_column = ['GRDCDESC', 'EMOGDESC', 'BSCDDESC', 'USERNAME', 'CHKRESDTM'];

    const isSearched = true;

    const sendData = JSON.parse(localStorage.getItem('boardCheckData'));

    const [loading, setLoading] = useState(false);
    
    const popupData = async () => {
        try {
            const response = await axios.get('/commonapi/boardCheckList.do',
                { params: sendData }
            );
            setData(response.data);
            setLoading(false);
        } catch (e) {
            console.error('body 내용 로딩 중 오류 발생', e);
        }
    }

    useEffect(() => {
        setLoading(true);
        popupData();
    }, []);

    return (
        <div className='popup_font popup_container bg_ho_bg'>
            <div className='flex justify-between items-center'>
                <h4 className='sub_title mb-0'>게시글 확인자</h4>
                {/* <button onClick={() => window.close()} className='comm_btn bg_co_black h-7 self-end'>닫기</button> */}
            </div>
            <div className='flex flex-col gap-2 h-full'>
                <div className='flex justify-between items-center'>
                    <span className='total_items'>전체&nbsp;<strong className='ho_color'>{data.length}</strong>건</span>
                    {data.length === 0 ? '' :
                        <div className='btn_container pr-1'>
                            <ExcelDownload excelHead={head} searched={isSearched} excelData={data} dataCode={head_column} excelFileName='게시글 확인자 리스트' />
                        </div>
                    }
                </div>
                {loading ? <Loading /> :
                    <PopupDataGrid
                        dataHead={head}
                        dataColumn={head_column}
                        dataList={data}
                    />
                }
            </div>
        </div>
    )
}

export default BoardCheck_popup